import { defineStore } from 'pinia';

export const useMarketSegmentStore = defineStore('market-segment', {
    state: () => ({
        marketSegments: [] as any[],
        marketSegment: null as any | null,
    }),
    actions: {
        async fetchMarketSegments() {
            return useNuxtApp().$api().v2.marketSegments.list({
                retry: 3,
                retryDelay: 1500,
            }).then(response => {
                this.marketSegments = response
                return response;
            });
        },
        async fetchMarketSegment(id: string) {
            this.marketSegment = await useNuxtApp().$api().v2.marketSegments.get(id);
        },
    }
})